import { DestroyRef, Directive, inject, input, OnChanges, TemplateRef, ViewContainerRef } from '@angular/core';
import { Country } from '@core/locations/models/country.enum';
import { UserInfoFacade } from '@core/user-info/facades/user-info.facade';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { asNonUndefined } from '@kaseya-utils';
import { first } from 'rxjs';

@Directive({
  selector: '[itcCountryAccess]',
})
export class CountryAccessDirective implements OnChanges {
  private readonly destroyRef = inject(DestroyRef);
  private readonly userInfoFacade = inject(UserInfoFacade);
  private readonly templateRef = inject(TemplateRef<never>);
  private readonly viewContainer = inject(ViewContainerRef);

  readonly itcCountryAccess = input<Country[]>();

  ngOnChanges(): void {
    if (!this.itcCountryAccess()) {
      this.viewContainer.createEmbeddedView(this.templateRef);
      return;
    }

    this.checkCountryAccess();
  }

  private checkCountryAccess(): void {
    this.userInfoFacade.userInfo$.pipe(first(), takeUntilDestroyed(this.destroyRef)).subscribe(() => {
      if (this.userInfoFacade.isUserFromCountries(asNonUndefined(this.itcCountryAccess()))) {
        this.viewContainer.createEmbeddedView(this.templateRef);
        return;
      }

      this.viewContainer.clear();
    });
  }
}
